export default __webpack_public_path__ + "static/media/temp.9dccf2f8.svg";